export const routesConfig = [
    {
        label: "Dashboard",
        icon: "pi pi-th-large",
        path: "/dashboard"
    },
    {
        label: "Vault Access",
        icon: "pi pi-warehouse",
        path: "/vaultaccess"
    },
    {
        label: "Stock Reports",
        icon: "pi pi-chart-line",
        path: "/report"
    },
    {
        label: "Change Password",
        icon: "pi pi-lock",
        path: "/changepassword"
    },
    //FOR SUBMENU 
    //{
    //    label: "Stock Reports",
    //    icon: "pi pi-chart-line",
    //    children: [
    //        { label: "Default", path: "/reports" }
    //    ]
    //},
];